import { render } from "./UsuarioSelect.vue?vue&type=template&id=2c81079c"
import script from "./UsuarioSelect.vue?vue&type=script&lang=js"
export * from "./UsuarioSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__